import { useParams } from 'next/navigation'
import { useCallback } from 'react'

type RouteParams = Record<string, string | string[]>
const useRouteWithParams = () => {
  const params = useParams()

  const updatePathWithParams = useCallback((path: string, extraParams: RouteParams = {}): string => {
    if ((!params || Object.keys(params).length === 0) && Object.keys(extraParams).length === 0) {
      return path
    }
    const mergedParams = { ...(params || {}), ...extraParams } as const
    return Object.entries(mergedParams).reduce((updatedPath, [param, value]) => {
      if (value) {
        return updatedPath.replace(`:${param}`, Array.isArray(value)
          ? value.join('/')
          : value)
      }
      return updatedPath
    }, path)
  }, [params])

  return {
    updatePathWithParams,
  }
}

export default useRouteWithParams
